var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appaboutcard"},[_c('div',{staticClass:"appaboutcard_item"},[_c('app-iconset',{attrs:{"icon":_vm.info.icon,"size":"110px","original":""}})],1),_c('div',{staticClass:"appaboutcard_item"},[_c('h3',[_vm._v(_vm._s(_vm.info.title))])]),_c('div',{staticClass:"appaboutcard_item"},[_c('p',[_vm._v(_vm._s(_vm.info.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }